import React from 'react';
import './App.css';

import Slides from './slides'

function App() {
  return (
    <Slides />
  );
}

export default App;
